export class MyChangeRequestsConstants {
    public static readonly MyChangeRequestsTitle = 'My Change Requests';
    public static readonly ChangeRequest_PanelListType = 'CRI';
}
